import React from 'react';

import { Button } from 'components/v2/Buttons/Button/Button';
import { Modal } from 'components/v2/Modal/Modal';
import { Text } from 'components/v2/Typography/Text';

import { AppleModalProps } from './AppleDisclaimerModal.types';

const AppleDisclaimerModal = (props: AppleModalProps) => {
  return (
    <Modal open={props.showModal} onCancel={props.handleClose} title="Apple sign-in disclaimer">
      <Text>
        If you choose to anonymize your email for sign up via Apple SSO, you will not be able to use
        another method to sign in later on.
      </Text>
      <Button label="Sign Up" onClick={props.handleClose} />
    </Modal>
  );
};

export default AppleDisclaimerModal;
